import { traceDepsToTerms } from "../utils/trace-deps-to-terms";
export function getTermDependents(sortedReactiveExpressions, expressionReference) {
    const terms = {};
    const iterables = {};
    for (const exp of sortedReactiveExpressions) {
        for (const refLocation of traceDepsToTerms(exp.dependencies, expressionReference)) {
            if (refLocation.type === "iterable-term") {
                if (!iterables[refLocation.iterableName]) {
                    iterables[refLocation.iterableName] = {
                        terms: {},
                    };
                }
                if (!iterables[refLocation.iterableName].terms[refLocation.termName]) {
                    iterables[refLocation.iterableName].terms[refLocation.termName] =
                        new Set();
                }
                iterables[refLocation.iterableName].terms[refLocation.termName].add(exp);
                continue;
            }
            if (!terms[refLocation.termName]) {
                terms[refLocation.termName] = new Set();
            }
            terms[refLocation.termName].add(exp);
        }
    }
    return {
        terms: Object.entries(terms).reduce((acc, [termName, exps]) => {
            acc[termName] = Array.from(exps);
            return acc;
        }, {}),
        iterables: Object.entries(iterables).reduce((acc, [iterableName, { terms }]) => {
            acc[iterableName] = {
                terms: Object.entries(terms).reduce((acc, [termName, exps]) => {
                    acc[termName] = Array.from(exps);
                    return acc;
                }, {}),
            };
            return acc;
        }, {}),
    };
}
//# sourceMappingURL=term-dependents.js.map